module.exports = __webpack_public_path__ + "img/point_icon.3b2dde4e.png";